import HallWithdrawModal from "./hall-withdraw-modal";

export default HallWithdrawModal;
